<template>
    <modal-dialog
        id="coupon-editor"
        :show.sync="shown"
        :dismissable="true"
    >
        <template v-slot:title>
            <span v-if="!!edited_record && !!edited_record.id && !!edited_record.code" class="h5">{{ translate("Coupon {code}", { code: edited_record.code }) }}</span>
            <span v-else class="h5">{{ translate("New Coupon") }}</span>
        </template>

        <section v-if="edited_record">
            <form-input
                id="code"
                name="code"
                v-model="edited_record.code"
                :required="true"
                :disabled="redeemed || !editable"
                @input="save"
            >
                <template v-slot:label>{{ translate("Code") }}</template>
                <template v-slot:hint>
                    <span v-if="!edited_record.id">{{ translate("Leave empty for an auto-generated code") }}</span>
                </template>
            </form-input>
            <div class="columns">
                <form-input
                    id="discount_percent"
                    type="stripe"
                    name="discount_percent"
                    v-model="edited_record.discount_percent"
                    :min="1"
                    :max="100"
                    :required="true"
                    :disabled="redeemed || !editable"
                    class="column col-6 col-md-12"
                    @input="save"
                >
                    <template v-slot:right_addon>
                        <span class="input-group-addon">
                            <app-icon glyph="percent" />
                        </span>
                    </template>
                    <template v-slot:label>{{ translate("Discount") }}</template>
                </form-input>
                <form-date-input
                    id="expires_on"
                    name="expires_on"
                    v-model="edited_record.expires_on"
                    :required="false"
                    :disabled="!editable"
                    class="column col-6 col-md-12"
                    @input="save_date"
                >
                    <template v-slot:label>{{ translate("Expires on") }}</template>
                </form-date-input>
            </div>
        </section>
        <template
            v-slot:footer
            v-if="!!edited_record && !edited_record.id"
        >
            <default-button
                :disabled="creating_record"
                class="mr-2"
                @click.prevent="shown = false"
            >
                {{ translate("Cancel") }}
            </default-button>
            <default-button
                color="success"
                :waiting="creating_record"
                :disabled="creating_record"
                class="ml-2"
                @click.prevent="record_save"
            >
                {{ translate("Add") }}
            </default-button>
        </template>
    </modal-dialog>
</template>

<script>
import { is_record_editor } from "@/nibnut/mixins"

import { ModalDialog, FormInput, FormDateInput, DefaultButton, AppIcon } from "@/nibnut/components"

export default {
    name: "CouponEditorDialog",
    mixins: [is_record_editor],
    components: {
        ModalDialog,
        FormInput,
        FormDateInput,
        DefaultButton,
        AppIcon
    },
    watch: {
        show: "reload"
    },
    methods: {
        grab_record_id () {
            this.record_id = this.couponId
        },
        record_save () {
            const data = {
                ...this.edited_record,
                ...this.ownerInfo
            }
            if(data.expires_on && !(data.expires_on instanceof Date)) data.expires_on = this.$dayjs(data.expires_on).format("YYYY-MM-DD")
            return this.save_data_for_record_id(this.entity, 0, data).then(record => {
                if(record) this.shown = false
            })
        }
    },
    computed: {
        shown: {
            get () {
                return this.show
            },
            set (show) {
                this.$emit("update:show", show)
            }
        },
        can_reload () {
            return !!this.profile_id && this.show
        },
        redeemed () {
            return !!this.edited_record && !!this.edited_record.id && !!this.edited_record.computed_uses
        }
    },
    props: {
        ownerInfo: {
            type: Object, // { owner_type: "", owner_id: 0 }
            required: true
        },
        couponId: {
            type: Number,
            default: 0
        },
        show: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            entity: "coupon",
            entityName: "coupon:::coupons"
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/sass/variables";
#coupon-editor {
    .modal-container .modal-body {
        overflow: visible;
    }
}
</style>
